import { type PriceType } from "./type";
import { type PlanDataTableFragmentFieldsFragment } from "@/components/fragments/argyle/plan-data-table/__gql__/plan-data-table-fragment.gen";
import { isNonNullable } from "@/modules/utils/predicate";

export const getPriceType = ({ subscriptionCoupon }: PlanDataTableFragmentFieldsFragment): PriceType => {
  if (!isNonNullable(subscriptionCoupon)) {
    return "normal";
  }

  if (
    subscriptionCoupon.duration === "once" ||
    (subscriptionCoupon.duration === "repeating" && subscriptionCoupon.durationInMonths === 1)
  ) {
    return "once";
  }

  if (subscriptionCoupon.duration === "repeating") {
    return "repeating";
  }

  return "forever";
};
